import { createAction, props } from '@ngrx/store';

export const loadPermissionsFromLogin = createAction(
  '[Permissions] Load From Login',
  props<{ permissions: string[] }>()
);

export const refreshPermissions = createAction('[Permissions] Refresh');

export const refreshPermissionsSuccess = createAction(
  '[Permissions] Refresh Success',
  props<{ permissions: string[] }>()
);

export const refreshPermissionsFailure = createAction(
  '[Permissions] Refresh Failure'
);

export const clearPermissions = createAction('[Permissions] Clear');
